
import request from './index'
const api = {
  projects: payload => {
    return request.get("/api/index", { params: payload })
  },
  createQuestion: payload => {
    return request.post("/api/create_question", payload)
  },
  getUser: payload => {
    return request.get('/web/user_info')
  },
  createUser: payload => {
    return request.post(`/api/create_user`, payload)
  },
  getUsers: payload => {
    return request.get("/api/users", { params: payload })
  },
  putUser: payload => {
    return request.post(`/api/users/${payload.id}`, payload)
  },
  deleteUser: payload => {
    return request.delete(`/api/users/${payload.id}`, payload)
  },
  getQuestion: payload => {
    return request.get("/api/questions", { params: payload })
  },
  getProcess: payload => {
    // console.log('get Proecess param:',payload)
    return request.get("/api/process", { params: payload })
  },
  login: payload => {
    return request.post("/web/login", payload)
  },
  getUserGrade: payload => {
    return request.get("/api/user_grade", { params: payload })
  },
  createEvent: payload => {
    return request.post(`/api/events/${payload.user_process_id}`, payload)
  },
  getEvents: payload => {
    return request.get(`/api/events/${payload.user_process_id}`, { params: payload })
  },
  createMission: payload => {
    return request.post("/api/create_mission", payload)
  },
  getDeparement: payload => {
    return request.get("/api/get_deparements", { params: payload })
  },
  getMissions: payload => {
    return request.get("/api/get_missions", { params: payload })
  },
  getMission: payload => {
    return request.get(`/api/mission/${payload.id}`, { params: payload })
  },
  handleMission: payload => {
    return request.post(`/api/mission/${payload.id}`, payload)
  },
  // putMission:payload => {
  //   return request.put(`/api`)
  // },
  postMissionMoment: payload => {
    return request.post(`/api/mission_moment`, payload)
  },
  getMissionMoment: params => {
    return request.get(`/api/mission_moment`, { params: params })
  },
  putMissionMoment: payload => {
    return request.put(`/api/mission_moment/${payload.id}`, payload)
  },
  deleteMissionMoment: payload => {
    return request.delete(`/api/mission_moment/${payload.id}`, payload)
  },
  getMissionUser: params => {
    return request.get(`/api/mission_user`, { params: params })
  },
  ding: payload => {
    return request.post(`/api/ding`, payload)
  },
  getWorkload: payload => {
    return request.get("/api/workload", { params: payload })
  },
  createWorkload: payload => {
    return request.post("/api/add_workload", payload)
  },
  getWeeks: payload => {
    return request.get("/api/get_weeks", { params: payload })
  },
  getShops: payload => {
    return request.get('/web/shops', { params: payload })
  },
  getShopMap: param => {
    return request.get(`/web/tape_project/${param.tape_project_id}`, { params: param })
  },
  getTapeImageList: (param) => {
    return request.get(`/web/tape_images`, { params: param })
  },
  createTapeOrder: (param) => {
    return request.post(`/web/tape_shop/${param.id}`, param)
  },
  deleteTapeOrder: payload => {
    return request.delete(`/web/tape_order/${payload.id}`, payload)
  },
  handleTapeOrder: payload => {
    return request.post(`/web/tape_order`, payload)
  },
  postTapeProject: payload => {
    return request.post(`/web/tape_project`, payload)
  },
  getTapeProject: params => {
    return request.get(`/web/tape_projects`, { params: params })
  },
  deleteTapeProject: param => {
    return request.delete(`/web/tape_project/${param.id}`)
  },
  getOrder: params => {
    return request.get(`/web/orders/${params.id}`)
  },
  getTapeOrder: payload => {
    return request.get('/web/get_tape_order', { params: payload })
  },
  deleteTapePoint:param => {
    return request.delete(`/web/tape_point/${param.id}`)
  },
  exportTapeProjectPoints: param => {
    return request.get(`/web/tape_project/${param.id}`, { params: param })
  },
  putTapeShop: param => {
    return request.put(`/web/tape_shop/${param.id}`, param)
  },
}

export default api
